import {Editor} from "../../../../../../pkg/slate.js";
export const isMarkActive = (editor, format) => {
  try {
    const marks = Editor.marks(editor);
    return marks ? marks[format] === true : false;
  } catch (err) {
    return false;
  }
};
